import React from 'react'
import { Flex } from 'grid-styled'
import Carousel from '../../elements/Carousel'
import Hide from '../../../styles/utilities/Hide'
import { Icon } from '../../elements/Icon'

import { ItemDescription, List } from './styles'

function renderItems(item) {
  return (
    <List key={item.id} width={[1, 4 / 12]}>
      <Icon icon={item.icon} height="75px" width="75px" viewBox="0 0 20 75" />
      <ItemDescription>{item.description}</ItemDescription>
    </List>
  )
}

function groupItems(items, limitItems) {
  const result = []
  let itemIndex = 0

  if (limitItems > 0) {
    while (itemIndex < items.length) {
      let cursor = 0
      const group = []

      while (group.length < limitItems && itemIndex < items.length)
        group[cursor++] = items[itemIndex++] // eslint-disable-line

      result.push(group)
    }
  }
  return result
}

const IconTextCarousel = ({ data }) => {
  const desktopItems = groupItems(data, 3)

  return (
    <div>
      {data && (
        <div>
          <Hide at="small">
            <Carousel hasNavigation hasArrow mobileOnly={false}>
              {desktopItems.map((group, index) => (
                <Flex align="stretch" key={index}>
                  {group.map(item => renderItems(item))}
                </Flex>
              ))}
            </Carousel>
          </Hide>
          <Hide at="large">
            <Carousel flexibleWidth hasNavigation mobileOnly={false}>
              {data.map(item => renderItems(item))}
            </Carousel>
          </Hide>
        </div>
      )}
    </div>
  )
}

export default IconTextCarousel



// WEBPACK FOOTER //
// ./src/app/modules/IconTextCarousel/index.js